import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import getPhoneHeader from "./PhoneHeader";
import Address from "./Address";
import AttIcon from "../../assets/images/carriers/att.jpg";
import SwbellIcon from "../../assets/images/carriers/SwBell.png";
import Verizoncon from "../../assets/images/carriers/verizon.jpg";
import SprintIcon from "../../assets/images/carriers/sprint.jpg";
import TmobileIcon from "../../assets/images/carriers/t-mobile.jpg";

export const getPhoneCarrierImage = (name) => {
  if (
    name.indexOf("att") !== -1 ||
    name.indexOf("Blue Licenses") !== -1 ||
    name.indexOf("ATT MOBIL") !== -1
  ) {
    return AttIcon;
  }
  if (name.indexOf("BELLSOUTH") !== -1) {
    return SwbellIcon;
  }
  if (name.indexOf("erizon") !== -1 || name.indexOf("ERIZON") !== -1) {
    return Verizoncon;
  }
  if (name.indexOf("Sprint") !== -1 || name.indexOf("SPRINT") !== -1) {
    return SprintIcon;
  }
  if (name.indexOf("T-Mobile") !== -1 || name.indexOf("T-MOBILE") !== -1) {
    return TmobileIcon;
  }
  return "";
};

export const getCarrierInfo = (props) => {
  const operatingCarrier = _.get(
    props.node,
    "carrier247[0].operatingCarrier[0]"
  );
  const carrierName = _.get(operatingCarrier, "name[0]._", "");
  const carrierImageName = getPhoneCarrierImage(carrierName);
  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.HeaderCell>
            Carrier Contact/Subpoena Information
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row
          key={`Carrier_Lookup_Name_Row_${props.index}`}
          className={props.colorClass}
        >
          <Table.Cell>
            <ul>
              <li className="noBullet">
                {carrierImageName !== "" && (
                  <img
                    key={`img_carrier`}
                    src={getPhoneCarrierImage(carrierName)}
                    alt="carrierImage"
                    width="32px"
                    height="32px"
                  />
                )}
                {carrierName}
              </li>
              <li className="noBullet">
                {_.get(operatingCarrier, "contactAddress[0]._", "")}
              </li>
              <li className="noBullet">{`${_.get(
                operatingCarrier,
                "contactCity[0]._",
                ""
              )} ${_.get(operatingCarrier, "contactState[0]._", "")} ${_.get(
                operatingCarrier,
                "contactPostalCode[0]._",
                ""
              )}`}</li>
              <li className="noBullet">{`${_.get(
                operatingCarrier,
                "contactFirstName[0]._",
                ""
              )} ${_.get(operatingCarrier, "contactLastName[0]._", "")}`}</li>
              <li className="noBullet">
                {_.get(operatingCarrier, "contactPhone[0]._", "")}
              </li>
            </ul>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export const getHistoricalCarrier = (props) => {
  const operatingCarriers = _.get(
    props.node,
    "historicalCarrier[0].operatingCarrier"
  );
  const results = [];
  if (operatingCarriers) {
    _.forEach(operatingCarriers, (operatingCarrier, opIndex) => {
      const carrierName = _.get(operatingCarrier, "name[0]._", "");
      const carrierImageName = getPhoneCarrierImage(carrierName);
      results.push(
        <ul key={`carrier_ul_${opIndex}`}>
          <li>
            {carrierImageName !== "" && (
              <img
                key={`img_carrier_${opIndex}`}
                src={getPhoneCarrierImage(carrierName)}
                alt="carrierImage"
                width="32px"
                height="32px"
              />
            )}{" "}
            {carrierName}
          </li>
          <li>{_.get(operatingCarrier, "contactAddress[0]._", "")}</li>
          <li>
            {`${_.get(operatingCarrier, "contactCity[0]._", "")}, ${_.get(
              operatingCarrier,
              "contactState[0]._",
              ""
            )} ${_.get(operatingCarrier, "contactPostalCode[0]._", "")}`}
          </li>
          <li>
            {`${_.get(operatingCarrier, "contactFirstName[0]._", "")} ${_.get(
              operatingCarrier,
              "contactLastName[0]._",
              ""
            )}`}
          </li>
          <li>{_.get(operatingCarrier, "contactPhone[0]._", "")}</li>
        </ul>
      );
    });
  }
  return (
    <Table>
      <Table.Body>
        <Table.Row>
          <Table.HeaderCell>Historical Carrier Information</Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>{results}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export const getListingDetails = (props) => {
  const lastName = _.get(props.node, "lastName[0]._", "");
  return (
    <Table.Row key={`Listing_Row_${props.index}`}>
      <Table.Cell>
        <Table key={`Listing_Table_${props.index}`} className={`sub-table`}>
          <Table.Body>
            {getPhoneHeader(props)}
            <Table.Row>
              <Table.Cell>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className={"sub-table-cell"}>
                        Name:
                      </Table.Cell>
                      {lastName !== "" ? (
                        <Table.Cell className={"sub-table-cell"}>
                          {getPersonName(
                            _.get(props.node, "firstName[0]._", ""),
                            "",
                            _.get(props.node, "lastName[0]._", ""),
                            props
                          )}
                        </Table.Cell>
                      ) : (
                        _.get(props.node, "listingName[0]._", "")
                      )}
                    </Table.Row>
                    <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {<Address addressNode={props.node} {...props} />}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        SMS Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {_.get(props.node, "carrier247[0].sms[0]._", "")}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row className={"table-no-border"}>
                      <Table.Cell className={"sub-table-cell"}>
                        MMS Address:
                      </Table.Cell>
                      <Table.Cell className={"sub-table-cell"}>
                        {_.get(props.node, "carrier247[0].mms[0]._", "")}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Cell>
              <Table.Cell>{getCarrierInfo(props)}</Table.Cell>
              <Table.Cell>{getHistoricalCarrier(props)}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};

export default getListingDetails;



// WEBPACK FOOTER //
// ./src/components/searchresults/ListingDetails.js